import React from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";
import { useEffect } from "react";
import { FaWhatsapp, FaInstagram, FaTelegram, FaPhone } from "react-icons/fa";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="main">
      {/* <QuickContact/> */}
      <Navbar />
      <div className="content">
        <div className="content-header-container">
          <div className="bg-pattern"></div>

          <h2 className="content-name">Reach Out To Us</h2>
        </div>

        <div className="contact-section">
          <div className="contact-details">
            <h1 className="contact-details-header">Contacts and Socials</h1>
            <div className="socials">
              <FaWhatsapp id="contact-social-icon" />
              <FaInstagram id="contact-social-icon" />
              <FaTelegram id="contact-social-icon" />
              <FaPhone id="contact-social-icon" />
            </div>

            <div className="map-location">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6723.869506807765!2d-0.25318721615063144!3d5.65196376777457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9ece84f47067%3A0x5fab4cade5302426!2sStar%20Of%20The%20East%20School!5e0!3m2!1sen!2sgh!4v1727889209242!5m2!1sen!2sgh"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          <div className="contact-form">
            <form action="">
              <h3>Send us a short note </h3>
              <input type="text" placeholder="Enter your Name" />
              <input type="text" placeholder="Email" />
              <textarea
                name=""
                id=""
                placeholder="Type your message here..."
              ></textarea>
              <button type="button">Submit</button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
